import React from "react";
import OrganisationCard from "../composant_reutilisable/Organisation_card";
import "../../CSS/OrganisationCard.css";

const OrganisationCountryBlock = ({ country, organisations }) => {
  return (
    <div className="org-list">
      <span className="org-country-title">{country}</span>

      <div className="org-card-list">
        {organisations.map((org, index) => (
          <OrganisationCard
            key={index}
            city={org.city}
            organisation={org.organisation}
            link={org.href}
          />
        ))}
      </div>
    </div>
  );
};

export default OrganisationCountryBlock;
